import {slideDown, slideUp} from "./utilities/slide";
import {XhrService} from "../ts/xhr.service";
import {addErrorClass, addLoadingClass, removeLoadingClass} from "./utilities/updateClasses";

function toggleVariants(itemlistElement, itemlistVariants) {
    if (itemlistElement.classList.contains("is-active")) {
        for (const variant of itemlistVariants) {
            slideUp(variant);
        }
        itemlistElement.classList.remove("is-active");
    } else {
        for (const variant of itemlistVariants) {
            slideDown(variant, 200, "linear", () => {
            }, "grid");
        }
        itemlistElement.classList.add("is-active");
    }
}

export function initItemlistToggle() {
    document.addEventListener("click", function (event) {
        const toggle = event.target.closest('.itemlistElement .js-toggleItemlistVariants');
        if (!toggle) return;

        const itemlistElement = toggle.closest('.itemlistElement');
        if (!itemlistElement) return;

        const toggles = itemlistElement.querySelectorAll(".js-toggleItemlistVariants");
        let itemlistVariants = itemlistElement.querySelectorAll('.itemlistElement__wrapper--isVariant');

        if (itemlistVariants.length === 0) {
            const itemNo = itemlistElement.dataset.itemno;
            const inputCounter = itemlistElement.dataset.inputcounter;
            const formData = new FormData();
            formData.set('item_no', itemNo);
            formData.set('input_counter', inputCounter);
            for (const e of toggles) {
                addLoadingClass(e);
            }

            XhrService.generalAjaxCall('loadItemVariants', formData, 'POST', 'json')
                .then(response => {
                    if (!response.status) {
                        throw "Could not get data";
                    }
                    const renderedVariants = response.renderedVariants;
                    if(renderedVariants === undefined) {
                        console.error('cannot find variants');
                        for (const e of toggles) {
                            addErrorClass(e);
                        }
                        return;
                    }
                    const newElement = document.createElement('div');
                    newElement.innerHTML = renderedVariants;
                    while (newElement.firstChild) {
                        itemlistElement.appendChild(newElement.firstChild);
                    }
                    newElement.remove();

                    itemlistVariants = itemlistElement.querySelectorAll('.itemlistElement__wrapper--isVariant');
                    if (itemlistVariants.length > 0) {
                        toggleVariants(itemlistElement, itemlistVariants);
                    }

                    for (const e of toggles) {
                        removeLoadingClass(e);
                    }
                })
                .catch((e) => {
                    console.error('Error:', e);
                    console.error(formData);
                    for (const e of toggles) {
                        addErrorClass(e);
                    }
                });
        } else {
            toggleVariants(itemlistElement, itemlistVariants);
        }
    });
}